import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 * B2C_1A_* use custom policy
 * B2C_1_* use built-in policy(not using them anymore)
 */
export const b2cPolicies = {
  names: {
    customSiSu: 'B2C_1A_SIGNUP_SIGNIN',
    customSimpleSiSu: 'B2C_1A_SIMPLE_SIGNUP_SIGNIN',
    customKosmosSignin: 'B2C_1A_KOSMOS_SIGNIN',
    customPasswordChange: 'B2C_1A_B2C_1A_PROFILE_EDIT_PASSWORD_CHANGE',
    customEditProfile: 'B2C_1A_PROFILEEDIT',
    customForgotPassword: 'B2C_1A_PASSWORDRESET',
    // default builtin user flows(cannot return role claim)
    signUpSignIn: 'B2C_1_susi',
    forgotPassword: 'B2C_1_pwreset',
    editProfile: 'B2C_1_edit_profile',
  },
  authorities: {
    customSiSu: {
      scopes: [`https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN`,
    },
    customSimpleSiSu: {
      scopes: [`https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_SIMPLE_SIGNUP_SIGNIN`,
    },
    customKosmosSignin: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_KOSMOS_SIGNIN`,
    },
    customPasswordChange: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_PROFILE_EDIT_PASSWORD_CHANGE`,
    },
    customEditProfile: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_PROFILEEDIT`,
    },
    customForgotPassword: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1A_PASSWORDRESET`,
    },
    signUpSignIn: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1_susi`,
    },
    forgotPassword: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1_pwreset`,
    },
    editProfile: {
      scopes: ['openid'],
      authority: `https://${APPLICATION_NAMESPACE}.b2clogin.com/${APPLICATION_NAMESPACE}.onmicrosoft.com/B2C_1_edit_profile`,
    },
  },
  authorityDomain: `${APPLICATION_NAMESPACE}.b2clogin.com`,
};
